import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Alert, Button, Form, FormGroup } from "reactstrap";
import { Form as FinalForm, Field } from "react-final-form";
import LogoCompany from "../common/LogoCompany";
import TextInput from "../common/TextInput";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { combineValidators, isRequired } from "revalidate";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../app/stores/rootStore";
import { FORM_ERROR } from "final-form";
import { IGuestPinFormValues, IGuestScreenValues } from "../../app/models/guest";

interface IParams {
 
}

const validate = combineValidators({
  code: isRequired("code"),
});

const ScreenCodeForm: React.FC<IParams> = ({  }) => {
  const rootStore = useContext(RootStoreContext);
  const { GetScreenByCode ,RedirectGuest} = rootStore.guestStore;

  const [t] = useTranslation(["guest"], translationHookOptions);

  return (
    <div className="form-wrapper mt-0">
      <div>
        <LogoCompany className="loginLogo" />
      </div>
      <h5 className="mt-5 mb-1">
        <b>{t("insert_screen_code")}</b>
      </h5>
      <FinalForm
        initialValues={{
          code: ""
        }}
        onSubmit={(values: IGuestScreenValues) =>
          GetScreenByCode(values).then(
            (dto) => { if(dto)  RedirectGuest(dto)}
          ).catch((error) => ({
            [FORM_ERROR]: error,
          }))
        }
        validate={validate}
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          dirtySinceLastSubmit,
        }) => (
          <Form onSubmit={handleSubmit} role="form">
            <FormGroup className="form-group input-group-lg">
              <Field
                className="form-control"
                name="code"
                component={TextInput}
                placeholder={t("screen_code_placeholder")}
                autoComplete="off"
              />
              <Field name="code" component={TextInput} type="hidden" />
            </FormGroup>
            {submitError && !dirtySinceLastSubmit && (
              <Alert color="danger">{t("invalid_screen_code")}</Alert>
            )}
            <div className="text-center mt-5">
              <Button
                disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                className="btn loginButton btn-block btn-lg"
                color="dark"
                type="submit"
              >
                {t("continue")}
              </Button>
            </div>
          </Form>
        )}
      />
      {/* <div className="text-center text-muted mt-4 mb-2">
        <h6 className="linedText">
          <span className="linedSpan">
            {t("login_method_separator", { ns: "translation" })}
          </span>
        </h6>
      </div>
      <div className="text-center text-muted mb-4">
        <a className="text-muted text-underline" href="/">
          <u>{t("email_login_link")}</u>
        </a>
      </div> */}
    </div>
  );
};

export default observer(ScreenCodeForm);
